import React from "react";
import "./sections.scss";


function ServiceSec({item,LinkDispatcher}){


    return(
        <div key={item.items && item.items[0]?.uid} className="triad-container">
            <div className="service-mobile-row">

                {item.items.map(i=>{
                    return(
                        <div className="service-mobile-item">

                            <div className="service-mobile-item-img">
                                <img src={i.image} alt=""/>
                            </div>

                            <div className="service-mobile-item-title">
                                <h5>{i.title}</h5>
                            </div>

                            <div className="service-mobile-item-desc">
                                <p>{i.text.substr(0,400)+"..."}</p>
                            </div>

                            <div className="service-mobile-item-btns" onClick={e=>{
                                LinkDispatcher(i.link_to, i)
                            }}>
                                <span>بیشتر</span>
                            </div>

                        </div>
                    )
                })}

            </div>
        </div>
    )
}

export default ServiceSec
